import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnER: CultureInfo = {
  name: 'en-ER',
  displayName: 'English (Eritrea)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-ER',
  parent: CultureInfoEn
};
